module.exports = __webpack_public_path__ + "media/img/uploads/program-office-us-marines-4bf7fc9616b36af74f142640845cff1e.jpg";